import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import STEPPER_FORM from "../../config/stepper-form";
import createOrganization from "../../util";
import { ORG_CREATE_TRIGGERED } from "../../form-store/action-types";
import Captcha from "../hcaptcha";
let STEP_INFO = STEPPER_FORM.map((stp, i) => ({ finsish: false, step: i + 1 }));

const FormAction = ({ handleBack, handleNext, step }) => {
  const validity = useSelector(({ form }) => form.formValidity);
  const formObj = useSelector(({ form }) => form, shallowEqual);
  const { hcaptcha, hcaptchaToken } = useSelector(({ captcha }) => captcha);
  const [stepper, setStepper] = useState(STEP_INFO);
  const dispatch = useDispatch();

  const handleNextClick = () => {
    setStepper(stp => {
      stp[step].finsish = true;
      return stp;
    });
    handleNext();
  };

  const orgCreation = token => {
    createOrganization(formObj, dispatch, { hcaptcha, hcaptchaToken: token });
    dispatch({ type: ORG_CREATE_TRIGGERED, payload: true });
  };

  const createOrgaReq = () => {
    if (hcaptcha && hcaptchaToken === "") {
      window.hcaptcha.execute();
      return;
    }
    orgCreation();
  };

  const isLastStep = () => step === STEPPER_FORM.length - 1;

  const onClick = () => {
    if (isLastStep()) createOrgaReq();
    else handleNextClick();
  };
  const StepStatus = () => (
    <div className="stepper-info">
      {stepper.map((stp, i) => (
        <span key={i} className={`step ${i === step ? "active" : ""} ${stp.finsish ? "finish" : ""}`}>
          {stp.finsish ? "" : stp.step}
        </span>
      ))}
    </div>
  );

  // useEffect(() => {
  //   document.addEventListener("keypress", e => {
  //     if(e.key === 'Enter' && !validity) {
  //       onClick();
  //     }
  //   });
  //   return function() {
  //     document.removeEventListener("keypress");
  //   };
  // }, []);

  return (
    <div className="sisp-stepper">
      <div className="sisp-btn-container">
        {hcaptcha && isLastStep() && (
          <div>
            <Captcha onSuccess={orgCreation} />
          </div>
        )}
        <div>
          {step !== 0 && (
            <Button onClick={handleBack} className="sisp-button-default">
              Go Back
            </Button>
          )}
          <Button type="submit" variant="contained" onClick={onClick} className={validity ? "sisp-button-primary" : "sisp-button-disabled"} 
           disabled={!validity || formObj.reqtriggered}
          >
            {isLastStep() ? "Submit" : "Next"}
          </Button>
        </div>
      </div>
      <StepStatus />
    </div>
  );
};

export default FormAction;
